// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"ea3a065c","453":"ce3a21f0","777":"9b226380"}[chunkId] + ".chunk.js";
};